import { render, staticRenderFns } from "./McmField.vue?vue&type=template&id=fa9fb542&scoped=true"
import script from "./McmField.vue?vue&type=script&lang=ts"
export * from "./McmField.vue?vue&type=script&lang=ts"
import style0 from "./McmField.vue?vue&type=style&index=0&id=fa9fb542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9fb542",
  null
  
)

export default component.exports